import $http from '../../axios'
import { Notification, MessageBox } from 'element-ui'

/**
 * Servicioi para traer las sedes del cliente
 * @author Brayan Ramirez
 * @type GET
 */
export async function fetchBranchOffices ({ commit, state }) {
    await $http.get('/api/sedes')
        .then((response) => {
            commit('setBranchOffices', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}

/**
 * Servicioi para traer los parametros de la tabla 071P
 * @type GET
 * @author Brayan Ramirez
 */
export async function fetchTypesUpdate({commit, state}, ) {
    await $http
        .get("/api/parametros-por-codigo/071P")
        .then(response => {
            commit("setTypeUpdates", response.data.data);
        })
        .catch(error => {
            state.loading.module = false
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}

/**
 * Servicioi para traer el priximo id de la tabla de novedades
 * @author Brayan Ramirez
 * @type GET
 */
export async function getNextId({ commit, state },validate = false) {
    $http
        .get("/api/next-id-novedad").then(response => {
        commit("setNextId", {data :response.data.data,validate :validate});
    })
        .catch(error => {
            console.log(error)
        });
}


/**
 * Servicioi para traer Las Novedades del sistema
 * @type GET
 * @author Brayan Ramirez
 */
export async function getListCashUpdates ({ commit, state }) {
  const branchofficesWarehouses = JSON.parse(localStorage.branchoffices_warehouses_all)

  let params = state.params;

  const findBw = branchofficesWarehouses.find(item => 
       item.id === state.params.branchoffice_warehouse_id 
    && item.branchoffice_id === state.params.branchoffice_id  
  )

  if (!findBw) {
    const bw = branchofficesWarehouses.filter(item => item.branchoffice_id === state.params.branchoffice_id)

    if (bw && bw.length > 0) {
      params.branchoffice_warehouse_id = bw[0].id; 
    }
  }

  await $http.get('/api/lista-novedades', { params: params })
  .then((response) => {
    commit('setListCashUpdates', response.data.data)
  });
}

export async function getListCashUpdatesExcel ({ commit, state }, dates) {
  commit('setIsLoadingReport', true);

  await $http.get('/api/lista-novedades-excel', { params: {
    ...state.params,
    dates
  } })
  .then((response) => {
    commit('setIsLoadingReport', false);
    commit('setListCashUpdatesExcel', response.data.data)
  })
  .catch(() => {
    commit('setIsLoadingReport', false);
    console.error('error :>> ', error);
    Notification.error({
      title: 'Error!',
      message: error.response && error.response.data ? error.response.data.message : 'error',
      type: 'error',
      duration: 2000,
      customClass: 'notification-box',
    });
  });
}

/**
 * Servicioi para traer Las Novedad
 * @type GET
 * @author Brayan Ramirez
 */
export async function getCashRegisterUpdate ({ commit }, id) {
  await $http.get(`/api/novedad/${id}`).then((response) => {
    commit('setSelectedCashUpdate', response.data.data)
  }).catch((error) => {
    console.error(error.message)
  })
}

/**
 * Servicioi para Crear  Novedad
 * @type Post
 * @author Brayan Ramirez
 */
export async function newCashRegisterUpdate({ state, dispatch }) {

  state.selectedCashRegisterUpdate.branchoffice_id = localStorage.selected_branchoffice;
  state.selectedCashRegisterUpdate.date = state.params.date;
  const params = state.selectedCashRegisterUpdate;

  return new Promise(async(resolve, reject) => {
      await $http.post('/api/crear-novedad', params)
        .then((response) => {
          dispatch('getListCashUpdates')
          Notification.success({
            title: 'Exito!',
            message: 'La novedad ha sido Creada correctamente',
            type: 'success',
            duration: 2000,
            customClass: 'notification-box',
          });
          resolve(response)
        })
        .catch((error) => {
          console.error('error :>> ', error);
            Notification.error({
              title: 'Error!',
              message: error.response && error.response.data ? error.response.data.message : 'error',
              type: 'error',
              duration: 2000,
              customClass: 'notification-box',
            });
            reject(error);
        })
  })
}

/**
 * Servicioi para Actualizar la  Novedad
 * @type PUT
 * @author Brayan Ramirez
 */
export async function updateCashRegisterUpdate({ state , dispatch}) {
    state.selectedCashRegisterUpdate.branchoffice_id = localStorage.selected_branchoffice;
    state.selectedCashRegisterUpdate.date = state.params.date;
    await $http.put(`/api/actualizar-novedad/${state.selectedCashRegisterUpdate.id}`, state.selectedCashRegisterUpdate).then(() => {
       dispatch('getListCashUpdates')
       Notification.success({
      title: 'Exito!',
      message: 'La novedad ha sido editado correctamente',
      type: 'success',
      duration: 2000,
      customClass: 'notification-box',
    });
  })
}


/**
 * Servicioi para Eliminar la  Novedad
 * @author Brayan Ramirez
 * @type delete
 */
export async function deleteCashRegisterUpdate({state,dispatch}, id) {

  await $http.delete(`/api/eliminar-novedad/${id}`).then(() => {
    dispatch('getListCashUpdates')
    Notification.success({
      title: 'Exito!',
      message: 'El impuesto ha sido eliminado correctamente',
      type: 'success',
      duration: 2000,
      customClass: 'notification-box',
    });

  }).catch(error => {
    console.error(error.message)
  })
}

export function setPerPagePagination ({ commit, dispatch }, perPage) {
  commit('setPerPage', parseInt(perPage.target.value))
  dispatch('getListCashUpdates')
}

export function setPagePagination ({ commit, dispatch }, page) {
  commit('setPage', parseInt(page))
  dispatch('getListCashUpdates')
}


export async function generateCashRegisterPdf({ commit, state }) {
    commit('setIsLoadingReport', true);
    commit("setLoadingPdf", true);
    commit("resetFileNamePdfCashRegister");

    var params = {
        params: state.params
    };

    $http
        .get("/api/pdf-novedades", params)
        .then(response => {
            commit('setIsLoadingReport', false);

            if(response.data === 'No hay registros'){
                Notification.success({
                    title: "¡success!",
                    message: "No hay registros en las fechas seleccionadas",
                    type: "success",
                    duration: 3500,
                    customClass: "notification-box"
                });
            }else{
                commit("setFileNamePdfCashRegister", response.data);
                commit("setShowPdfCashRegister", true);
            }

            commit("setLoadingPdf", false);
        })
        .catch(error => {
            commit('setIsLoadingReport', false);
            commit("setLoadingPdf", false);
            Notification.error({
                title: "¡Error!",
                message: "Error al crear el cuadre de caja.",
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}







// WEBPACK FOOTER //
// ./src/modules/cash-registers-updates/actions.js